import {FC} from 'react';

import {Tooltip, TooltipProps} from '@mui/material';

export type TooltipExtendedProps = TooltipProps & {
  disabled?: boolean;
};

export const TooltipExtended: FC<TooltipExtendedProps> = (props) => {
  const {disabled, children, ...rest} = props;

  if (disabled) {
    return children;
  }
  return <Tooltip {...rest}>{children}</Tooltip>;
};
